var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/containers/account-container.js";
import React from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { followAccount, unfollowAccount, blockAccount, unblockAccount, muteAccount, unmuteAccount } from '../actions/accounts';
import { openModal } from '../actions/modals';
import { initMuteModal } from '../actions/mutes';
import { getSettings } from '../actions/settings';
import Account from '../components/account';
import { makeGetAccount } from '../selectors';
const messages = defineMessages({
  unfollowConfirm: {
    "id": "confirmations.unfollow.confirm",
    "defaultMessage": "Unfollow"
  }
});

const makeMapStateToProps = () => {
  const getAccount = makeGetAccount();

  const mapStateToProps = (state, props) => ({
    account: getAccount(state, props.id)
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch, _ref) => {
  let {
    intl
  } = _ref;
  return {
    onFollow(account) {
      dispatch((_, getState) => {
        var _account$relationship, _account$relationship2;

        const unfollowModal = getSettings(getState()).get('unfollowModal');

        if ((_account$relationship = account.relationship) !== null && _account$relationship !== void 0 && _account$relationship.following || (_account$relationship2 = account.relationship) !== null && _account$relationship2 !== void 0 && _account$relationship2.requested) {
          if (unfollowModal) {
            dispatch(openModal('CONFIRM', {
              icon: require('@tabler/icons/minus.svg'),
              heading: /*#__PURE__*/React.createElement(FormattedMessage, {
                id: "confirmations.unfollow.heading",
                defaultMessage: "Unfollow {name}",
                values: {
                  name: /*#__PURE__*/React.createElement("strong", {
                    __self: this,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 42,
                      columnNumber: 125
                    }
                  }, "@", account.get('acct'))
                },
                __self: this,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 42,
                  columnNumber: 22
                }
              }),
              message: /*#__PURE__*/React.createElement(FormattedMessage, {
                id: "confirmations.unfollow.message",
                defaultMessage: "Are you sure you want to unfollow {name}?",
                values: {
                  name: /*#__PURE__*/React.createElement("strong", {
                    __self: this,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 43,
                      columnNumber: 151
                    }
                  }, "@", account.get('acct'))
                },
                __self: this,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 43,
                  columnNumber: 22
                }
              }),
              confirm: intl.formatMessage(messages.unfollowConfirm),
              onConfirm: () => dispatch(unfollowAccount(account.get('id')))
            }));
          } else {
            dispatch(unfollowAccount(account.get('id')));
          }
        } else {
          dispatch(followAccount(account.get('id')));
        }
      });
    },

    onBlock(account) {
      var _account$relationship3;

      if ((_account$relationship3 = account.relationship) !== null && _account$relationship3 !== void 0 && _account$relationship3.blocking) {
        dispatch(unblockAccount(account.get('id')));
      } else {
        dispatch(blockAccount(account.get('id')));
      }
    },

    onMute(account) {
      var _account$relationship4;

      if ((_account$relationship4 = account.relationship) !== null && _account$relationship4 !== void 0 && _account$relationship4.muting) {
        dispatch(unmuteAccount(account.get('id')));
      } else {
        dispatch(initMuteModal(account));
      }
    },

    onMuteNotifications(account, notifications) {
      dispatch(muteAccount(account.get('id'), notifications));
    }

  };
};

export default injectIntl(connect(makeMapStateToProps, mapDispatchToProps)(Account));